import { appTranslate } from '../../i18n';

const BACKEND_ERROR_KEYS = {
    user_already_activated: 'errors.backend.user_already_activated',
    user_not_found: 'errors.backend.user_not_found',
    unauthorized: 'errors.backend.unauthorized',
} as const;

export const translateBackendError = (errorCode?: string): string => {
    const key = errorCode && BACKEND_ERROR_KEYS[errorCode as keyof typeof BACKEND_ERROR_KEYS];
    if (key) {
        return appTranslate<string>(key);
    }

    return errorCode || appTranslate<string>('errors.general.unspecified');
};
